export enum TypeList {
  TRUSTED = 1,
  BLOCKED = 0
}
